<template>

    <header
        :class="{'menulist-open':showOpenClass}"
    >
        <div
            class="bg-overlay"
            @click="closeAll($event)"
        >&nbsp;</div>
        <div>
            <div class="site-logo">
                <inertia-link href="/" rel="home">
                    <img
                        :src="require('../../sass/sustainableclothing/img/logo.png').default"
                        :alt="shopName"
                    />
                </inertia-link>
            </div>
            <div class="menu-wrapper">
                <nav :class="{'navbar navbar-expand-md':true,'mobile-opened':menu}">
                    <div class="navbar-collapse" id="mainmenu">
                        <ul class="nav flex-column">
                            <li
                                class="nav-item closemenu text-right"
                            >
                                <a href="#" class="nav-link"
                                    @click.prevent="toggleMenu"
                                >
                                    <i class="mdi mdi-close"></i>
                                </a>
                            </li>
                            <menu-link
                                v-for="menulink in menuItems"
                                :menulink="menulink"
                                :key="'menulink-' + menulink.route"
                                @menuLinkClicked="menu = false"
                            ></menu-link>
                        </ul>
                    </div>
                </nav>

                <div class="header-tools">
                    <div class="row text-center">
                        <div class="col-3 col-xl-4">
                            <a
                                href="#"
                                @click.prevent="toggleLocaleChanger"
                            >
                                <i class="mdi mdi-flag-variant"></i>
                                <span class="sr-only" v-text="lang('menu.changelocale')" />
                                <span class="count">{{ localeData.current }}</span>
                            </a>
                            <div
                                :class="{'menulist text-left':true, 'open':locale}"
                            >
                                <locale-changer
                                    @closeLocaleChanger="locale = false"
                                    :localeData="localeData"
                                ></locale-changer>
                            </div>
                        </div>
                        <div class="col-3 col-xl-4">
                            <a
                                href="#"
                                @click.prevent="$emit('openSearch')"
                            >
                                <i class="mdi mdi-magnify"></i>
                                <span class="sr-only" v-text="lang('menu.search')" />
                            </a>
                        </div>
<!--                        <div class="col-4">
                            <a
                                href="#"
                                @click.prevent="toggleWishlist"
                            >
                                <i class="mdi mdi-heart-outline"></i>
                                <span class="sr-only">Wishlist bekijken</span>
                                <span class="count">0</span>
                            </a>
                            <div
                                :class="{'wishlist menulist text-left':true, 'open': wishlist}"
                            >
                                <div class="menulist-wrapper">
                                    <div class="menulist-header">
                                        <h3>Wishlist</h3>
                                        <div>
                                            <a href="#"
                                                @click.prevent="wishlist = false"
                                            >
                                                <i class="mdi mdi-close-box-outline"></i>
                                                <span class="sr-only">Wishlist sluiten</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="menulist-content">
                                        Content
                                    </div>
                                </div>
                            </div>
                        </div>-->
                        <div class="col-3 col-xl-4">
                            <a
                                href="#"
                                @click.prevent="toggleMinicart"
                            >
                                <i class="mdi mdi-cart-outline"></i>
                                <span class="sr-only" v-text="lang('menu.viewcart')" />
                                <span class="count">{{ getCart.count }}</span>
                            </a>
                            <div
                                :class="{'minicart menulist text-left':true, 'open':minicart}"
                            >
                                <minicart
                                    @closeMinicart="minicart = false"
                                    :cart="getCart"
                                ></minicart>
                            </div>
                        </div>
                    </div>

                    <div class="mobile-hamburger">
                        <a
                            href="#"
                            @click.prevent="toggleMenu"
                        >
                            <i class="mdi mdi-menu"></i>
                            <span class="sr-only" v-text="lang('menu.openmenu')" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </header>

</template>

<script>

import MenuItem from "../Libraries/MenuItem";
import MenuLink from "../components/Shared/MenuLink";
import Minicart from "../components/Cart/Minicart";
import LocaleChanger from "../components/LocaleChanger";
import {mapActions, mapGetters} from "vuex";

export default {

    components: {
        MenuLink,
        Minicart,
        LocaleChanger,
    },

    computed: {
        ...mapGetters([
            'getCart',
        ]),

        allBrands() {
            if (!this.$page.props.brands) {
                return [];
            }

            return this.$page.props.brands.data;
        },

        brandMenuItems() {
            return this.allBrands.map(brand => {
                return new MenuItem(brand.name, this.route('brands.item', {slug: brand.slug}));
            })
        },

        isAuthenticated() {
            if (!this.$page.props.auth) {
                return false;
            }

            return !!this.$page.props.auth.email;
        },

        localeData() {
            return this.$page.props.locale || {};
        },

        menuItems() {
            let menu = [
                new MenuItem(this.lang('menu.home'), this.route('home')),
                new MenuItem(this.lang('menu.brands'), this.route('brands.index'), this.brandMenuItems),
                new MenuItem(this.lang('menu.new'), this.route('category.new')),
                new MenuItem(this.lang('menu.bestsellers'), this.route('bestsellers.index')),
                new MenuItem(this.lang('menu.shop'), this.route('products.index'), [
                    new MenuItem(this.lang('menu.unisex'), this.route('categories.item', {slug:this.lang('menu.slugs.unisex')}), [
                        new MenuItem(this.lang('menu.tshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.unisex'), slug:this.lang('menu.slugs.tshirts')})),
                        new MenuItem(this.lang('menu.sweaters'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.unisex'), slug:this.lang('menu.slugs.sweaters')})),
                        new MenuItem(this.lang('menu.jackets'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.unisex'), slug:this.lang('menu.slugs.jackets')})),
                        new MenuItem(this.lang('menu.poloshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.unisex'), slug:this.lang('menu.slugs.poloshirts')})),
                        new MenuItem(this.lang('menu.trousers'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.unisex'), slug:this.lang('menu.slugs.trousers')})),
                    ]),
                    new MenuItem(this.lang('menu.ladies'), this.route('categories.item', {slug:this.lang('menu.slugs.ladies')}), [
                        new MenuItem(this.lang('menu.tshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.ladies'), slug:this.lang('menu.slugs.tshirts')})),
                        new MenuItem(this.lang('menu.sweaters'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.ladies'), slug:this.lang('menu.slugs.sweaters')})),
                        new MenuItem(this.lang('menu.jackets'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.ladies'), slug:this.lang('menu.slugs.jackets')})),
                        new MenuItem(this.lang('menu.poloshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.ladies'), slug:this.lang('menu.slugs.poloshirts')})),
                        new MenuItem(this.lang('menu.shirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.ladies'), slug:this.lang('menu.slugs.shirts')})),
                        new MenuItem(this.lang('menu.trousers'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.ladies'), slug:this.lang('menu.slugs.trousers')})),
                        new MenuItem(this.lang('menu.sweaterdresses'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.ladies'), slug:'sweater-dresses'})),
                    ]),
                    new MenuItem(this.lang('menu.gentlemen'), this.route('categories.item', {slug:this.lang('menu.slugs.gentlemen')}), [
                        new MenuItem(this.lang('menu.tshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.gentlemen'), slug:this.lang('menu.slugs.tshirts')})),
                        new MenuItem(this.lang('menu.sweaters'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.gentlemen'), slug:this.lang('menu.slugs.sweaters')})),
                        new MenuItem(this.lang('menu.jackets'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.gentlemen'), slug:this.lang('menu.slugs.jackets')})),
                        new MenuItem(this.lang('menu.poloshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.gentlemen'), slug:this.lang('menu.slugs.poloshirts')})),
                        new MenuItem(this.lang('menu.shirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.gentlemen'), slug:this.lang('menu.slugs.shirts')})),
                        new MenuItem(this.lang('menu.trousers'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.gentlemen'), slug:this.lang('menu.slugs.trousers')})),
                    ]),
                    new MenuItem(this.lang('menu.kids'), this.route('categories.item', {slug:this.lang('menu.category_slugs.kids')}), [
                        new MenuItem(this.lang('menu.tshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.kids'), slug:this.lang('menu.slugs.tshirts')})),
                        new MenuItem(this.lang('menu.sweaters'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.kids'), slug:this.lang('menu.slugs.sweaters')})),
                        new MenuItem(this.lang('menu.poloshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.kids'), slug:this.lang('menu.slugs.poloshirts')})),
                        new MenuItem(this.lang('menu.trousers'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.kids'), slug:this.lang('menu.slugs.trousers')})),
                    ]),
                    new MenuItem(this.lang('menu.babies'), this.route('categories.item', {slug:this.lang('menu.category_slugs.babies')}), [
                        new MenuItem(this.lang('menu.tshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.babies'), slug:this.lang('menu.slugs.tshirts')})),
                        new MenuItem(this.lang('menu.sweaters'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.babies'), slug:this.lang('menu.slugs.sweaters')})),
                        new MenuItem(this.lang('menu.trousers'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.babies'), slug:this.lang('menu.slugs.trousers')})),
                    ]),
                    /* The sports subcategories have been disabled for now, because we don't serve any sportswear specifics yet. */
                    new MenuItem(this.lang('menu.sports'), this.route('categories.item', {slug:this.lang('menu.category_slugs.sports')})/*, [
                        new MenuItem(this.lang('menu.unisex'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.category_slugs.unisex')}), [
                            new MenuItem(this.lang('menu.tshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.unisex.tshirts')})),
                            new MenuItem(this.lang('menu.sweaters'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.unisex.sweaters')})),
                            new MenuItem(this.lang('menu.jackets'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.unisex.jackets')})),
                            new MenuItem(this.lang('menu.poloshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.unisex.poloshirts')})),
                            new MenuItem(this.lang('menu.trousers'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.unisex.trousers')})),
                        ]),
                        new MenuItem(this.lang('menu.ladies'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.category_slugs.ladies')}), [
                            new MenuItem(this.lang('menu.tshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.ladies.tshirts')})),
                            new MenuItem(this.lang('menu.sweaters'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.ladies.sweaters')})),
                            new MenuItem(this.lang('menu.jackets'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.ladies.jackets')})),
                            new MenuItem(this.lang('menu.poloshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.ladies.poloshirts')})),
                            new MenuItem(this.lang('menu.trousers'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.ladies.trousers')})),
                        ]),
                        new MenuItem(this.lang('menu.gentlemen'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.category_slugs.gentlemen')}), [
                            new MenuItem(this.lang('menu.tshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.gentlemen.tshirts')})),
                            new MenuItem(this.lang('menu.sweaters'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.gentlemen.sweaters')})),
                            new MenuItem(this.lang('menu.jackets'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.gentlemen.jackets')})),
                            new MenuItem(this.lang('menu.poloshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.gentlemen.poloshirts')})),
                            new MenuItem(this.lang('menu.trousers'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.gentlemen.trousers')})),
                        ]),
                        new MenuItem(this.lang('menu.kids'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.category_slugs.kids')}), [
                            new MenuItem(this.lang('menu.tshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.kids.tshirts')})),
                            new MenuItem(this.lang('menu.sweaters'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.kids.sweaters')})),
                            new MenuItem(this.lang('menu.poloshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.kids.poloshirts')})),
                            new MenuItem(this.lang('menu.trousers'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.sports'), slug:this.lang('menu.slugs.sports.kids.trousers')})),
                        ]),
                    ]*/),
                    /* The workwear subcategories have been disabled for now, because we don't serve any workwear specifics yet. */
                    new MenuItem(this.lang('menu.workwear'), this.route('categories.item', {slug: this.lang('menu.category_slugs.workwear')})/*, [
                        new MenuItem(this.lang('menu.tshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.workwear'), slug:this.lang('menu.slugs.tshirts')})),
                        new MenuItem(this.lang('menu.sweaters'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.workwear'), slug:this.lang('menu.slugs.sweaters')})),
                        new MenuItem(this.lang('menu.jackets'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.workwear'), slug:this.lang('menu.slugs.jackets')})),
                        new MenuItem(this.lang('menu.poloshirts'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.workwear'), slug:this.lang('menu.slugs.poloshirts')})),
                        new MenuItem(this.lang('menu.trousers'), this.route('categories.custom.item', {category_slug:this.lang('menu.category_slugs.workwear'), slug:this.lang('menu.slugs.trousers')})),
                    ]*/),
                ]),
                new MenuItem(this.lang('menu.accessories'), this.route('categories.item', {slug:this.lang('menu.category_slugs.accessories')}), [
                    new MenuItem(this.lang('menu.headwear'), this.route('categories.item', {slug:this.lang('menu.category_slugs.headwear')})),
                    new MenuItem(this.lang('menu.towelsrobes'), this.route('categories.item', {slug:this.lang('menu.category_slugs.household-linen')})),
                    new MenuItem(this.lang('menu.bags'), this.route('categories.item', {slug:this.lang('menu.category_slugs.bags')})),
                    // Disabled, because there are no products yet: new MenuItem(this.lang('menu.shoes'), this.route('categories.item', {slug:this.lang('menu.category_slugs.shoes')})),
                    new MenuItem(this.lang('menu.underwear'), this.route('categories.item', {slug:this.lang('menu.category_slugs.underwear')})),
                    // Disabled, because there are no products yet: new MenuItem(this.lang('menu.swimwear'), this.route('categories.item', {slug:this.lang('menu.category_slugs.swimwear')})),
                ]),
                new MenuItem(this.lang('menu.allcategories'), this.route('categories.index'), [], true),
                new MenuItem(this.lang('menu.whitelabel'), this.route('content.index', {any:this.lang('menu.slugs.whitelabel')}), [], true),
                new MenuItem(this.lang('menu.blogs'), this.route('content.index', {any:this.lang('menu.slugs.blogs')})),
            ];

            if (this.isAuthenticated) {
                menu.push(new MenuItem(this.lang('menu.myaccount'), this.route('auth.myaccount.index')));
                menu.push(new MenuItem(this.lang('menu.logout'), this.route('auth.logout')));
            } else {
                menu.push(new MenuItem(this.lang('menu.login'), this.route('guest.login')));
                menu.push(new MenuItem(this.lang('menu.register'), this.route('guest.register')));
            }

            return menu;
        },

        shopName() {
            return this.$page.props.name;
        },

        showOpenClass() {
            return this.wishlist === true ||
                this.minicart === true ||
                this.menu === true ||
                this.locale === true;
        },
    },

    data() {
        return {
            locale:false,
            menu:false,
            minicart:false,
            wishlist:false,
        }
    },

    methods: {
        ...mapActions([
            'fetchCart'
        ]),
        closeAll() {
            this.locale = false;
            this.wishlist = false;
            this.minicart = false;
            this.menu = false;
        },
        toggleLocaleChanger() {
            if (this.locale === false) {
                this.wishlist = false;
                this.minicart = false;
                this.menu = false;
            }
            this.locale = !this.locale;
        },
        toggleMenu() {
            if (this.menu === false) {
                this.wishlist = false;
                this.minicart = false;
                this.locale = false;
            }
            this.menu = !this.menu;
        },
        toggleMinicart() {
            if (this.minicart === false) {
                this.wishlist = false;
                this.menu = false;
                this.locale = false;
            }
            this.minicart = !this.minicart;
        },
        toggleWishlist() {
            if (this.wishlist === false) {
                this.minicart = false;
                this.menu = false;
                this.locale = false;
            }
            this.wishlist = !this.wishlist;
        },
    },

    mounted() {
        this.fetchCart();
    },

    name:'ShopHeader',

}

</script>
